/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * SurveyIcon
 */
export default class SurveyIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M18 1a3 3 0 013 3v16a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 013-3h12zm0 2H6a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1zm-7.735 12.322a1 1 0 111.47 1.356l-2.77 3a1 1 0 01-1.49-.023l-1.23-1.418a1 1 0 011.51-1.31l.499.574zm1.413-5.557a1 1 0 01.136 1.316l-.08.097-2.768 3a1 1 0 01-1.402.067l-.088-.09-1.231-1.418a1 1 0 011.422-1.4l.088.09.499.574 2.011-2.18a1 1 0 011.413-.056zm0-5.5a1 1 0 01.136 1.316l-.08.097-2.768 3a1 1 0 01-1.402.067l-.088-.09-1.231-1.418a1 1 0 011.422-1.4l.088.09.499.574 2.011-2.18a1 1 0 011.413-.056z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

